import React from 'react';
import Testemonial from '../components/Testimonial';


const TestimonialList = () => {

    return(
        <>
            <section id="testemonials-container">
                <Testemonial/>
            </section>
        </>
    )

};

export default TestimonialList;